 




  import React from "react"
import { HandleImages } from "../components/functions"
import Layout from "../components/layout"
import "../css/terms.css"
 
import ActOnNew from "../components/act-on/act-on-new"


class Cancel extends React.Component {
 
  render() {
    return (
      <Layout>
      
<div className="terms-wrapper">
        <div>
            <HandleImages name="aresSplash"/>
        </div>
        
        <div>
        
			 

        <div  className="terms">

        <div style={{margin:"1em"}}>
            <h1>Cancel Subscription</h1>
           </div>
            
 <ActOnNew  id="58d7fe27-f6c0-4d91-acd7-3ddd0fd46969:d-0001"/>
 
</div>




        </div>
        
        
        
        </div>
      </Layout>
    )
  }
}

export default Cancel

